import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/FormRow.scss';

export default function FormRow({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.row, className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

FormRow.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
